import { cn } from "@newxsystems/shared";
import { BlockActions } from "../../../shared/components/BlockActions/BlockActions";
import { BlockCommonContent } from "../../../shared/components/BlockCommonContent/BlockCommonContent";
import { BlockContainer } from "../../../shared/components/BlockContainer/BlockContainer";
import { BlockRichText } from "../../../shared/components/BlockRichText/BlockRichText";
import type { IWysiwygStandardProps } from "./WysiwygStandard.props";

export const WysiwygStandard = ({
  alignment,
  anchorId,
  buttons,
  content,
  description,
  eyebrow,
  heading,
  spacing,
}: IWysiwygStandardProps) => {
  const hasCommonContent = Boolean(eyebrow || heading || description);

  return (
    <BlockContainer anchorId={anchorId} spacing={spacing}>
      <BlockCommonContent
        alignment={alignment}
        description={description}
        eyebrow={eyebrow}
        heading={heading}
        headingLevel="h2"
      />
      {buttons?.length ? (
        <BlockActions
          actions={buttons}
          alignment={alignment}
          className={cn(hasCommonContent && "mt-10")}
        />
      ) : null}
      <BlockRichText
        className={cn(
          "text-start text-base/[1.6] text-onSurface-500 [overflow-wrap:anywhere] md:text-[17px]",
          (hasCommonContent || buttons?.length) && "mt-12",
          "[&_a]:text-electric-blue [&_a]:underline [&_a]:underline-offset-4 [&_a]:[overflow-wrap:anywhere] [&_a]:focus-visible:outline-2 [&_a]:focus-visible:outline-offset-3 [&_a]:focus-visible:outline-ring",
          "[&_h1]:mt-12 [&_h1]:text-[34px]/[1] [&_h1]:font-semibold [&_h1]:tracking-[-0.025em] [&_h1]:[overflow-wrap:anywhere] md:[&_h1]:text-[44px]/[1] [&_h2]:mt-12 [&_h2]:text-[34px]/[1] [&_h2]:font-semibold [&_h2]:tracking-[-0.025em] [&_h2]:[overflow-wrap:anywhere] [&_h3]:mt-10 [&_h3]:text-[24px]/[1.15] [&_h3]:font-semibold [&_h3]:[overflow-wrap:anywhere]",
          "[&_h4]:mt-8 [&_h4]:text-[17px]/[1.55] [&_h4]:font-semibold [&_h4]:[overflow-wrap:anywhere] [&_h5]:mt-6 [&_h5]:text-[17px]/[1.55] [&_h5]:font-semibold [&_h5]:[overflow-wrap:anywhere] [&_h6]:mt-6 [&_h6]:text-[17px]/[1.55] [&_h6]:font-semibold [&_h6]:[overflow-wrap:anywhere]",
          "[&_h1+*]:mt-6 [&_h2+*]:mt-6 [&_h3+*]:mt-5 [&_h4+*]:mt-4 [&_h5+*]:mt-4 [&_h6+*]:mt-4 [&_ol]:ml-5 [&_ol]:list-decimal [&_p+p]:mt-4 [&_ul]:ml-5 [&_ul]:list-disc",
        )}
        content={content}
      />
    </BlockContainer>
  );
};

WysiwygStandard.displayName = "Wysiwyg::WysiwygStandard";
